export const DEFAULT_AUTHENTICATION_CONFIG: AuthenticationConfig = {
    config: {},
};

export type AuthenticationConfig = {
    config: {
        [key: string]: string,
    },
};

export const CALLBACK_PATH = '/login/callback';
